import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { for: "uso" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "flex justify-between" }

import { TblVaccinazione } from "@/../../EshJSLib/models/patient";
import { onMounted, reactive } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vacciniConfidenzialita',
  emits: ["cancel"],
  setup(__props, { expose: __expose, emit }) {

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const store = patientStore();
const { patient } = storeToRefs(store);
let vaccininew = ref({} as TblVaccinazione);
const alertConfirmMessage = ref<null | string>(null);
const showConfirm = ref(false);
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;


onMounted(() => {
  initFlowbite();
});



function openModal(message: string, rowData: TblVaccinazione): Promise<boolean> {

  vaccininew.value = rowData
  alertConfirmMessage.value = message;
  showConfirm.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });

}

function saveVaccini() {

alertModal.value.openModal("Sei sicuro di salvare i dati?", true).then((userInput) => {

  if (userInput) {
    showConfirm.value = false;
    if (!resolvePromise) return;
       resolvePromise(true);
  }
});

}

function closeModal() {
  store.fetchVaccini();
  showConfirm.value = false
  if (!resolvePromise) return;
         resolvePromise(false);
  emit("cancel");
  
}



__expose({ openModal });


return (_ctx: any,_cache: any) => {
  return (showConfirm.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        size: "2xl",
        onClose: _cache[3] || (_cache[3] = ($event: any) => (closeModal()))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Seleziona il livello di confidenzialita: ')), 1)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t(" Livello di confidenzialità * ")), 1),
            _withDirectives(_createElementVNode("select", {
              id: "uso",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(vaccininew).id_livello_confidenzialita) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, (item, key) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.id_livello_confidenzialita,
                  key: key
                }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_4))
              }), 128))
            ], 512), [
              [_vModelSelect, _unref(vaccininew).id_livello_confidenzialita]
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (closeModal())),
              type: "button",
              class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            }, _toDisplayString(_ctx.$t('Annulla')), 1),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (saveVaccini())),
              type: "button",
              class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            }, _toDisplayString(_ctx.$t('Salva')), 1)
          ]),
          _createVNode(AlertModal, {
            ref_key: "alertModal",
            ref: alertModal
          }, null, 512)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})